document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.cart-socks-add').forEach(button => {

    button.addEventListener('click', async () => {

      const variantId = button.dataset.variantId;

      if (!variantId) return;

      button.disabled = true;
      button.textContent = '追加中...';

      try {

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

        if (!response.ok) {
          throw new Error('Add to cart failed');
        }

        button.textContent = '追加しました ✓';

        // Broadcastテーマへカート更新を通知
        document.dispatchEvent(
          new CustomEvent('theme:update:cart')
        );

      } catch (error) {

        console.error(error);

        button.textContent = 'エラー';

      }

      setTimeout(() => {
        button.disabled = false;
        button.textContent = 'カートに追加';
      }, 1500);

    });

  });

});